module.exports = __webpack_public_path__ + "static/media/sybaseiq.f617c9c0.svg";